import React, { useMemo } from 'react';

import { MenuDropdownType } from '#/components/layout/header/headerTypes';
import MenuItemRenderer from '#/components/layout/header/MenuItemRenderer';

import HeaderMenuDropdown from './HeaderMenuDropdown';

export default function DropdownMenuItem({
  menuItem,
  onClick,
  disableDropdown,
  hoverColor,
  onHover,
  leftAligned,
  paddingRight,
}: {
  menuItem: MenuDropdownType;
  disableDropdown?: boolean;
  hoverColor?: string;
  onClick?: () => void;
  onHover?: (isHovered: boolean) => void;
  leftAligned?: boolean;
  paddingRight?: string;
}) {
  const menuItems = useMemo(
    () =>
      menuItem.items.map((dropdownMenuItem, idx) => {
        return (
          <MenuItemRenderer
            key={idx}
            menuItem={dropdownMenuItem}
            linkProps={{ onClick }}
          />
        );
      }),
    [menuItem.items, onClick]
  );

  return (
    <HeaderMenuDropdown
      disableDropdown={disableDropdown}
      label={menuItem.label}
      tooltip={menuItem.tooltip}
      hoverColor={hoverColor}
      onHover={onHover}
      onLabelClick={onClick}
      leftAligned={leftAligned}
      paddingRight={paddingRight}
    >
      {menuItems}
    </HeaderMenuDropdown>
  );
}
